module.exports = __webpack_public_path__ + "static/media/brazil.fd3c0e2b.svg";